import type { TRuleWithTheme } from '@ackee/fela';

import bulletImg from '../../../../../static/images/bullet.svg';

export const container: TRuleWithTheme = () => ({});

export const link: TRuleWithTheme = ({ theme: { colors, transition } }) => ({
    fontWeight: 'inherit',
    color: colors.blue,
    textDecorationColor: colors.blue,

    transition,
    transitionProperty: 'color',

    ':hover': {
        color: colors.fuchsia,
    },
});
export const image: TRuleWithTheme = () => ({
    margin: '2.5rem auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '50rem',
});

export const imageCaption: TRuleWithTheme = () => ({
    textAlign: 'center',
    fontSize: '0.875em',
    margin: '-1.5rem 0 2.5rem 0',
});

export const button: TRuleWithTheme = ({ theme: { colors, transition } }) => ({
    padding: '0.75rem',
    borderRadius: '0.25rem',
    backgroundColor: colors.blue,
    color: colors.white,
    cursor: 'pointer',

    transition,

    ':hover': {
        backgroundColor: colors.darkBlue,
    },
});

export const video: TRuleWithTheme = () => ({
    margin: '2.5rem auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '50rem',
});

export const htmlContainer: TRuleWithTheme = ({ theme }, renderer) => ({
    '& p': {
        fontSize: '1.125rem',
        fontWeight: '500',
        lineHeight: '1.875rem',

        '& strong': {
            fontWeight: '800',
        },
    },

    '& a': {
        ...link({ theme }, renderer),
        overflowWrap: 'break-word',
    },

    '& ul': {
        paddingLeft: '0.5rem',

        '& li': {
            listStyle: 'none',
            fontSize: '1.125rem',
            lineHeight: '1.875rem',
            paddingLeft: '1.5rem',
            marginBottom: '0.25rem',
        },

        '& li::before': {
            content: `url(${bulletImg})`,
            position: 'absolute',
            display: 'inline-block',
            transform: 'translateY(-15%)',
            marginLeft: '-1.5rem',
            marginRight: '0.6875rem',
        },
    },

    '& ol': {
        paddingLeft: '2.5rem',

        '& li': {
            fontSize: '1.125rem',
            lineHeight: '1.875rem',
            paddingLeft: '1rem',
            marginBottom: '0.25rem',
        },
    },

    '& h1': {
        fontSize: '3rem',
        fontWeight: '800',
        lineHeight: '3.625rem',
        marginTop: '4rem',
        marginBottom: '1.5rem',
    },

    '& h2': {
        fontSize: '2rem',
        fontWeight: '800',
        lineHeight: '2.5rem',
        marginTop: '4rem',
        marginBottom: '1.5rem',
    },

    '& h3': {
        fontSize: '1.5rem',
        fontWeight: '800',
        lineHeight: '2.125rem',
        marginTop: '4rem',
        marginBottom: '1rem',
    },

    '& h4': {
        fontSize: '1.375rem',
        fontWeight: '600',
        lineHeight: '2.1875rem',
        letterSpacing: '0.0625rem',
        textTransform: 'uppercase',
        marginTop: '4rem',
        marginBottom: '1rem',
    },

    '& table': {
        width: '100%',
        borderCollapse: 'collapse',
        '& th, td': {
            padding: '0.5rem',
        },
        '& th': {
            color: theme.colors.blue,
            borderBottom: `2px solid ${theme.colors.blue}`,
            fontFamily: theme.fonts.heroNewBold,
            fontWeight: 700,
            fontSize: '1rem',
            lineHeight: '1.625rem',
            textAlign: 'start',
        },
        '& td': {
            borderBottom: `2px solid #EFEFEF`,
            fontSize: '0.875rem',
            fontWeight: '500',
            lineHeight: '1.625rem',

            '& a': {
                color: theme.colors.black,
                textDecorationColor: theme.colors.black,
            },
        },
        '& tr :is(td,th):first-child::before': {
            minHeight: 44,
        },
    },
});
